import React from "react";
import { motion } from "framer-motion";

// ⚠️ Set the WhatsApp number in international format: country code + number,
// NO "+", spaces, or dashes. Example: India 98765 43210 -> "919876543210".
const WHATSAPP_NUMBER = "916354440379"; // 91 (India) + 6354440379

// Pre-filled message the visitor's WhatsApp opens with.
const DEFAULT_MESSAGE = "Hi, I'd like to know more about TeamGrid.";

/**
 * Floating WhatsApp click-to-chat button.
 * Bottom-left so it never collides with the bottom-right AI chat widget.
 * Mount this only on pages where we want it (e.g. Landing) — it is NOT global.
 */
const WhatsAppButton = ({
  number = WHATSAPP_NUMBER,
  message = DEFAULT_MESSAGE,
}) => {
  // Don't render a broken link if the number hasn't been configured yet.
  if (!number || number === "REPLACE_WITH_NUMBER") return null;

  const href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
      className="fixed bottom-5 left-5 md:bottom-6 md:left-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-black/20 hover:shadow-xl"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, delay: 0.6 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Official WhatsApp glyph */}
      <svg
        viewBox="0 0 32 32"
        className="w-8 h-8"
        fill="#FFFFFF"
        aria-hidden="true"
      >
        <path d="M16.004 2.667c-7.36 0-13.333 5.973-13.333 13.333 0 2.347.613 4.64 1.776 6.661L2.667 29.333l6.84-1.792a13.27 13.27 0 0 0 6.497 1.656h.005c7.355 0 13.333-5.973 13.333-13.333 0-3.563-1.387-6.912-3.907-9.432a13.24 13.24 0 0 0-9.431-3.765zm0 24.027h-.004a11.07 11.07 0 0 1-5.64-1.544l-.405-.24-4.06 1.064 1.083-3.957-.264-.42a11.03 11.03 0 0 1-1.69-5.864c0-6.115 4.977-11.092 11.096-11.092 2.963 0 5.747 1.155 7.84 3.251a11.02 11.02 0 0 1 3.247 7.847c0 6.117-4.977 11.094-11.093 11.094zm6.084-8.307c-.333-.167-1.973-.973-2.279-1.085-.305-.112-.528-.167-.751.167-.223.333-.862 1.085-1.057 1.308-.195.223-.39.25-.723.083-.333-.167-1.408-.519-2.682-1.655-.991-.884-1.661-1.976-1.856-2.31-.195-.333-.021-.513.146-.679.15-.149.333-.39.5-.585.167-.195.223-.334.334-.557.111-.223.056-.418-.028-.585-.083-.167-.751-1.811-1.029-2.479-.271-.651-.546-.563-.751-.573l-.64-.011c-.223 0-.585.083-.891.418-.305.334-1.168 1.141-1.168 2.785s1.196 3.23 1.363 3.453c.167.223 2.354 3.594 5.701 5.039.797.344 1.418.55 1.902.704.799.254 1.527.218 2.103.132.642-.096 1.973-.806 2.251-1.585.278-.779.278-1.446.195-1.585-.083-.139-.305-.223-.638-.39z" />
      </svg>
    </motion.a>
  );
};

export default WhatsAppButton;
